/**
 * Builds the in-page anchor id used for each locality card on the
 * Local Shifting page, so internal links always land on the right card.
 */
export const areaAnchorId = (name: string): string =>
  `area-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

/**
 * Builds the URL slug for a locality's dedicated landing page.
 * e.g. "JP Nagar" -> "jp-nagar"
 */
export const areaPageSlug = (name: string): string =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");